var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"#030104","d":"M21.5,4.9c-1.6-1.6-3.8-2.5-6-2.5c-2.3,0-4.5,0.9-6.1,2.6c-2.7,2.7-3.2,7-1.3,10.3l6.7,9.5\r\n\t\tc0.3,0.4,0.8,0.5,1.2,0.2c0.1-0.1,0.2-0.1,0.2-0.2l6.7-9.5C24.8,11.9,24.2,7.6,21.5,4.9z M21.9,14.9l-6.5,9.2l-6.5-9.2\r\n\t\tc-2.2-3.6-1-8.3,2.5-10.5c1.2-0.7,2.6-1.1,3.9-1.1c2.7,0,5.1,1.4,6.5,3.7c1.4,2.3,1.5,4.5,0.3,7.5L21.9,14.9z","key":0}),React.createElement("path",{"fill":"#030104","d":"M15.4,6.7c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5s4.5-2,4.5-4.5S17.8,6.7,15.4,6.7z M15.4,14.6\r\n\t\tc-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5S17.3,14.6,15.4,14.6z","key":1})]));
}

Pin.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 30.8 27.6","enableBackground":"new 0 0 30.8 27.6","xmlSpace":"preserve"};

module.exports = Pin;

Pin.default = Pin;
